import type { ModelAddButtonOptions } from "@/modules/model-add-button";

import AssetTypeTemplateCreate from "@/modules/asset-type-template/asset-type-template-create";
import ModelAddButton from "@/modules/model-add-button";

const AssetTypeTemplateAddButton = (options: ModelAddButtonOptions) => {
  return (
    <ModelAddButton
      model="technicalform"
      component={<AssetTypeTemplateCreate />}
      {...options}
    />
  );
};

export default AssetTypeTemplateAddButton;
